import { render, staticRenderFns } from "./OnlinePaymentSettings.vue?vue&type=template&id=aca96246&scoped=true"
import script from "./OnlinePaymentSettings.vue?vue&type=script&lang=js"
export * from "./OnlinePaymentSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aca96246",
  null
  
)

export default component.exports